import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Paper, PaperProps } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import Draggable from 'react-draggable';
import TaskChat from './TaskChat';
import { ChatType, ChatScope } from '../../types/chat-enums';

interface TaskChatModalProps {
    taskId: string;
    open: boolean;
    onClose: () => void;
    chatType: ChatType; // Добавляем
    chatScope: ChatScope; // Добавляем
    initiatorId?: string; // Добавляем
}

interface PaperComponentProps extends PaperProps {
}

const PaperComponent = (props: PaperComponentProps) => {
    const { children, ...other } = props;
    const nodeRef = React.useRef(null);
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel='[class*="MuiDialogContent-root"], [class*="MuiDialogActions-root"], [class*="MuiIconButton-root"], [class*="MuiButton-root"]'
            nodeRef={nodeRef}
        >
            <Paper ref={nodeRef} {...other}>
                {children}
            </Paper>
        </Draggable>
    );
};

const TaskChatModal: React.FC<TaskChatModalProps> = ({ taskId, open, onClose, chatType, chatScope, initiatorId }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                Чат по задаче
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <TaskChat taskId={taskId} chatType={chatType} chatScope={chatScope} initiatorId={initiatorId} />
            </DialogContent>
        </Dialog>
    );
};

export default TaskChatModal;
